import { useState } from 'react'
import StreetTab from './customers/StreetTab'
import WholesaleTab from './customers/WholesaleTab'

type TabKey = 'street' | 'wholesale'

const tabs: { key: TabKey; label: string }[] = [
  { key: 'street', label: 'Clientes de Calle' },
  { key: 'wholesale', label: 'Mayoristas (Bodegas / Tiendas)' },
]

/** Same vendedor-facing Clientes page, split into two tabs by sales channel
 * (see distribution.customers.channel) -- street customers keep the exact
 * flow this page always had, wholesale accounts get their own tab because
 * they need a negotiated price per product before a sale is allowed. This
 * is a tab, not a new panel: the same seller manages both, no new
 * role/permission plumbing involved. */
export default function CustomersPage() {
  const [activeTab, setActiveTab] = useState<TabKey>('street')

  return (
    <div>
      <h1 className="text-2xl font-bold text-espresso-800 mb-6">Clientes</h1>

      <div role="tablist" aria-label="Canal de cliente" className="flex flex-wrap gap-1 border-b border-espresso-200 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.key}
            role="tab"
            aria-selected={activeTab === tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-2 text-sm font-medium rounded-t-md border-b-2 -mb-px focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta-500 ${
              activeTab === tab.key
                ? 'border-terracotta-600 text-terracotta-700 bg-terracotta-50'
                : 'border-transparent text-espresso-500 hover:text-espresso-800 hover:bg-cream-100'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div role="tabpanel">
        {activeTab === 'street' && <StreetTab />}
        {activeTab === 'wholesale' && <WholesaleTab />}
      </div>
    </div>
  )
}
